import {Component, EventEmitter, Inject, Output} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {ToothUiManagerModel} from './tooth-ui-manager/tooth-ui-manager.model';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ToothPickerConfigModel} from './tooth-picker-config.model';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-tooth-picker',
  templateUrl: './tooth-picker.component.html',
  styleUrls: ['./tooth-picker.component.css']
})
export class ToothPickerComponent {
  selectedTeeth: ToothUiManagerModel[] = [];
  isSingleToothMode: boolean;
  isEnableSurfacePick = false;

  @Output() notifySave: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<ToothPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ToothPickerConfigModel
  ) {
    if (data) {
      this.isSingleToothMode = !data.isMultiSelect;
      if (data.selectedTeeth && data.selectedTeeth.length > 0) {
        for (const t of data.selectedTeeth) {
          const model = new ToothUiManagerModel(true, t);
          model.toothModel = t;
          this.selectedTeeth.push(model);
        }
      }
    }
  }

  onToothSelectionChange(event) {
    this.selectedTeeth = event;
  }

  cancel() {
    this.close(false);
  }

  save() {
    this.close(true);
  }

  close(success: boolean) {
    if (!success) {
      this.dialogRef.close(false);
    } else {
      if (this.notifySave) {
        this.notifySave.emit(this.selectedTeeth);
        this.dialogRef.close(this.selectedTeeth);
      } else {
        this.dialogRef.close(this.selectedTeeth);
      }
    }
  }

  onSurfacePickChange(event: MatCheckboxChange) {
    this.isEnableSurfacePick = event.checked;
  }
}
